<template>
  <div class="ibSetting-box">
    <!--
      内容：用bootStrap panel类包裹
      提高体验： 加上 element 的loading特效功能 -->
    <div class="panel"
      v-loading.fullscreen="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.5)">
      <!--
        子组件：主体内容部分
        props通信传递数据：
          thData表头、trData表主体、handle操作的信息、page分页信息、multiLanguage多语言、sort排序方式、
          seekDropdown搜索所需的选项、selPage条目信息（配合分页使用）、region地区信息、isSetting设定的状态
        emit自定义事件：
          tableChange事件，触发后向后台拿表格数据；
          downLoadExcelFn事件，触发后下载excel表格；
          seek事件，搜索时触发，触发后向后台拿表数据。 -->
      <itable
        :thData="thData"
        :trData="trData"
        :handle="handle"
        :page="page"
        :multiLanguage="multiLanguage"
        :sort="sort"
        :seekDropdown="seekDropdown"
        :selPage="selPage"
        :region='curArea'
        :isSetting='isSetting'
        :ibSpecialType='ibSpecialType'
        :ibc.sync='ibc'
        :modifyTime.sync='modifyTime'
        :confirmTime.sync='confirmTime'
        :templateSel='templateSel'
        :ibTemplate ='ibTemplate'
        @tableChange="tableAjax"
        @downLoadExcelFn="excelDown"
        @seek="tableAjax">
      </itable>
    </div>
  </div>
</template>

<script>
  import itable from "./iTable" // 导入 子组件：主体内容
  import { Api } from 'api/commissionEnv' // 导入 Api(构造函数) commission 配置项
  import { URL_IBALL } from 'api/commissionApi' // 导入 URL_IBALL（获取所有代理列表）接口
  var api = new Api() // 创建实例 api

  export default {
    mixins: [ require("common/mixin/base.js").base({multiLanguage:"commissionTable"}),
      require("common/mixin/base.js").base({ibCommissionLan:"ibCommission"}), ], // 导入 多语言commissionTable，作用：渲染子组件需要的所有翻译。
    props: ['curArea','status'], // 接受父组件传递过来的curArea地区信息，作用：子组件根据它发ajax。注意这里是：非第三方组件，此处可以不用验证传入的内容，所以用数组字符串的形式接受props。
    components: { // 子组件声明
      itable,
    },
    data () {
      return {
        loading: false, // 作用：存放loading的状态，能默认不启动loading。
        trData: [], //  作用：存放表主体数据
        isSetting: { // 作用：存放设定的状态
          /**
           * active:
           *  * 当前活动的状态，作用是发ajax请求去后台拿数据时，告诉后台需要什么状态的数据；
           *  * 是个布尔类型，false表示未设定的状态，true表示已设定的状态，而如果为null,这不告诉后台，那么將返回全部状态数据。
           *
           * listActive:
           *  * 页面上属于状态的下拉菜单，根据这个值来显示当前选中的是哪个状态。
           *
           * list:
           *  * 状态列表：allStatus全部状态、sated已设定、unsated未设定
           */
          active: this.status ? this.status : null,
          listActive: this.status && this.status == '0' ? 'unsated' : this.status && this.status == '1' ? 'unchecked' : 'allStatus',
          list: { allStatus: "allStatus", sated: "sated", unsated: "unsated",checked: 'checked',unchecked: 'unchecked' }
        },
        ibSpecialType:{
          active: 2,
          listActive: 'all'
        },
        ibc: "",
        sort: {  // 作用：存放排序信息：key排序的关键字段，methods排序的方法
          key: "node_id",
          method: "ASC"
        },
        handle: {  //  作用：存放操作信息：link跳转的地址，idKey调整时传递的关键字段是id
          link: "ibCommissionSetting",
          idKey: "node_id",
        },
        seekDropdown: {  // 作用：存放搜索的选项
          active: 'loginId', // list坐标
          seekStr: "",  // 搜索内容
          list: {  // 搜索项列表
            loginId: "node_id",
            userName: "name",
            phone: "phone",
            email: "email"
          },
        },
        page: {  // 作用：存放分页信息
          active: 1,
          pageLeng: 0,
          offset: 0  // 查询数据库的offset需要的值，初始只为0组件内部处理最后给出一个能直接传给后台的值
        },
        selPage: {  // 作用：配合分页的显示col数目选择
          list: [5, 10, 25, 50],  // 选择显示col数目
          active: localStorage.pageMaxIndex,  // 当前list的坐标
          limit: [5, 10, 25, 50][localStorage.pageMaxIndex]  // 查询数据库的limit需要的值，初始值设为list的0坐标组件内部处理最后给出一个传给后台的值
        },
        modifyTime:'',
        confirmTime:'',
        templateSel:{active:'allTemplateId',overwritten:2},
        ibTemplate: {},
      }
    },
    mounted () {
      /**
       * 每次挂载这个组件成功后
       *  * 初始化 搜索的内容
       *  * 初始化 表格数据
       */
      this.seekDropdown && (this.seekDropdown.seekStr = "")
      this.tableAjax()
    },
    computed: {
      thData() {  // 表格th数据
        return [
            this.multiLanguage.th.specialCommission,
            this.multiLanguage.th.loginId,
            this.multiLanguage.th.ibcAccount,
            this.multiLanguage.th.IBCode,
            this.multiLanguage.th.accountName,
            this.multiLanguage.th.phone,this.multiLanguage.th.email,
            this.multiLanguage.th.updateBy,this.multiLanguage.th.confirmBy,
            this.multiLanguage.th.template,
            this.multiLanguage.th.status,this.multiLanguage.th.settingStatus
        ]
      }
    },
    methods: {
      tableAjax() { // 请求表格数据的方法
        try {
           /**
         * 先启动loading效果
         * 准备ajax的参数：{offset,limit,sortKey,sort,seekKey,seekVal,isSetting}
         * 发起ajax请求，注意这里的url要动态传入，成功之后拿到表主体数据赋值给 this.trData,还有条目总数
         * 所有操作完成之后，关闭loading效果
         */
        this.loading = true

        let offset = this.page.offset,
            limit = this.selPage.limit,
            sortKey = this.sort.key,
            sort = this.sort.method,
            seekKey = this.seekDropdown.list[this.seekDropdown.active],
            seekVal = this.seekDropdown.seekStr,
            isSetting = this.isSetting.active,
            isSpecial = this.ibSpecialType.active,
            ibc = this.ibc,
            modifyTime = this.modifyTime,
            confirmTime = this.confirmTime,
            templateId = this.templateSel.active,
            templateOverwritten = this.templateSel.overwritten

        this.$http(api.getUrl20(this.curArea,URL_IBALL),
          {params: {limit, offset, sortKey, sort, seekKey, seekVal,
            isSetting,ibc,isSpecial,modifyTime,confirmTime,templateId,templateOverwritten}}).then((res) => {
          let data = res.data.data
          if(data.ibTemplate) this.ibTemplate = data.ibTemplate.reduce((s,i)=>{
            s[i.templateId] = i
            return s
          },{allTemplateId:{templateId:'allTemplateId',langKey:'ib_allTemplate'}})
          var tmp = []
          data.rows.forEach((item) => {
            let tempId = this.ibTemplate[item.templateId]?this.ibTemplate[item.templateId].langKey:''
            if(!this.ibCommissionLan[tempId]) tempId = item.templateId
            tmp.push (
              {
                isSpecial: item.isSpecial,
                node_id: item.nodeId,
                ibc: item.ibc,
                node_code: item.nodeCode,
                name: item.name,
                phone: item.phone,
                email: item.email,
                updateBy: item.modifyBy,
                confirmBy: item.confirmBy,
                enable: item.enable,
                ib_rebatesetting: item.ibSetting,
                templateId: tempId || '',
                templateOverwritten: item.templateOverwritten,
              }
            )
          })
          this.trData = tmp
          this.page.pageLeng = data.count
          this.loading = false
        }).catch((err) => {
          this.loading = false
        })
        } catch (error) {
          this.loading = false
        }

      },
      excelDown () { // 下载excel表格的方法：先发ajax请求拿到数据
        /**
         * 准备ajax的参数：{offset,limit,sortKey,sort,seekKey,seekVal,isSetting}
         * 发起ajax请求，注意这里的url要动态传入，成功之后拿到 excel表主体数据 保存在一个变量中excelData,并遍历它对其中的一些数据做翻译
         * 准备一个变量excelTH保存 excel表头信息
         * 最后调用 export2Excel 生成excel表格
         */
        let offset = this.page.offset,
            limit = this.page.pageLeng,
            sortKey = this.sort.key,
            sort = this.sort.method,
            seekKey = this.seekDropdown.list[this.seekDropdown.active],
            seekVal = this.seekDropdown.seekStr,
            isSetting = this.isSetting.active,
            isSpecial = this.ibSpecialType.active,
            ibc = this.ibc,
            modifyTime = this.modifyTime,
            confirmTime = this.confirmTime,
            templateId = this.templateSel.active,
            templateOverwritten = this.templateSel.overwritten

        this.$http(api.getUrl20(this.curArea,URL_IBALL),{params: {limit, offset, sortKey, sort, seekKey, seekVal,
          isSetting,ibc,isSpecial,modifyTime,confirmTime,templateId,templateOverwritten}}).then((res) => {
          let excelData = []
          let ibtemplate = {}
          if(res.data.data.ibTemplate) ibtemplate = res.data.data.ibTemplate.reduce((s,i)=>{
            s[i.templateId] = i
            return s
          },{allTemplateId:{templateId:'allTemplateId',langKey:'ib_allTemplate'}})
          let data = res.data.data.rows
          data.forEach(item => {
            let tem = {}
            for ( let key in item) {
              if ( key == 'enable') {
                tem[key] = item[key] == 0  ? this.multiLanguage.ibStatus.disenable : this.multiLanguage.ibStatus.enable
              }
              else if ( key == 'ibSetting' ) {
                tem[key] = item[key] == 0 ? this.multiLanguage.isSetting.unsated : item[key] == 1 ? this.multiLanguage.isSetting.unchecked : this.multiLanguage.isSetting.checked
              }
              else if ( key == 'isSpecial' ) {
                tem[key] = item[key] == 0 ? 'N' : 'Y'
              }
              else if ( key == 'templateId') {
                let lang = item[key]?ibtemplate[item[key]].langKey:''
                tem[key] = this.ibCommissionLan[lang] || item[key]
                if(item['templateOverwritten']) tem[key] += '(Overwritten)'
              }
              else if ( key == 'modifyTime' || key == 'confirmTime' || key == 'templateOverwritten' ) {
              }
              else tem[key] = item[key]
            }
            excelData.push(tem)
          })
          let excelTH = Object.keys(excelData[0])
          this.export2Excel(excelTH,excelData)
        })
      },
      export2Excel (excelTH,excelData) { // 下载excel表格的方法：拿到 excel表头和excel表主体数据 之后利用插件Export2Excel.js生成excel表格
        let thRes = []
        for (let code of excelTH) {
          code == 'nodeId' && thRes.push(this.multiLanguage.th.loginId)
          code == 'ibc' && thRes.push(this.multiLanguage.th.ibcAccount)
          code == 'nodeCode' && thRes.push(this.multiLanguage.th.IBCode)
          code == 'name' && thRes.push(this.multiLanguage.th.accountName)
          code == 'phone' && thRes.push(this.multiLanguage.th.phone)
          code == 'email' && thRes.push(this.multiLanguage.th.email)
          code == 'enable' && thRes.push(this.multiLanguage.th.status)
          code == 'ibSetting' && thRes.push(this.multiLanguage.th.settingStatus)
          code == 'isSpecial' && thRes.push(this.multiLanguage.th.specialCommission)
          code == 'modifyBy' && thRes.push(this.multiLanguage.th.updateBy)
          code == 'confirmBy' && thRes.push(this.multiLanguage.th.confirmBy)
          code == 'templateId' && thRes.push(this.multiLanguage.th.template)
        }
        require.ensure([], () => {
          const { export_json_to_excel } = require('@/vendor/Export2Excel')
          const tHeader = thRes
          const filterVal = excelTH
          const list = excelData
          const data = this.formatJson(filterVal, list)
          export_json_to_excel(tHeader, data, 'excel')
        })
      },
      formatJson(filterVal, jsonData) { // export2Excel这个方法所需要的一个方法，作用：格式数据
        return jsonData.map(v => filterVal.map(j => v[j]))
      },
    },
    watch: {
      curArea () { // 监听：curArea 地区发生变化时，根据地区不同，初始化的baseUrl，之后执行tableAjax方法
        this.tableAjax()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ibSetting-box{
    margin-top: 20px;
    padding: 0 20px 60px 20px;
  }
</style>




// WEBPACK FOOTER //
// ibSettingView.vue?455575eb